export const langSupported = [
  'ar',
  'en',
  'es',
  'hi',
  'zh',
  'bn',
  'pt',
  'ru',
  'fr',
  'ur',
];
export const langSupportedWithSlash = [
  // "/ar",
  '/en',
  '/es',
  '/hi',
  '/zh',
  '/bn',
  '/pt',
  '/ru',
  '/fr',
  // "/ur",
];

export const allowRouters = [
  '/',
  '/crop-image',
  '/seo-tags-extractor',
  '/url-redirects',
  '/shorten-links',
  '/whatsapp-message-link-generator',
  '/qr-code-generator',
  '/base64-image-encoder',
];
